<template>
  <div id="page-onboarding" class="processes d-flex">
    <MainBarMenu />
    <div class="layout-content container-fluid">
      <div class="row">
        <div class="col-md-6 pt-4">
          <h2 class="mb-4">PROCESO DISCIPLINARIO - RD{{ id }}</h2>
          <div class="row process-info-2 mx-1 mb-5">
            <p>Información del colaborador</p>
            <div class="col-md-5 p-2">
              <span class="icon icon-persona mx-1"></span>
              {{ employee.core_employee.name }}
            </div>
            <div class="col-md-7 p-2">
              <span class="icon icon-calendario mx-1"></span>
              Fecha de la presunta falta:
              {{ formatDate(report.date_knowledge) }}
            </div>
            <div class="col-md-4 p-2">
              <span class="icon icon-id mx-1"></span>
              {{ employee.core_employee.sharp_id }}
            </div>
            <div class="col-md-4 p-2">
              <span class="icon icon-place mx-1"></span>
              {{ employee.site }}
            </div>
            <div class="col-md-4 p-2">
              <span class="icon icon-sindicato mx-1"></span>
              Sociedad: {{ employee.core_employee.society.name }}
            </div>
            <div class="col-md-12 p-2">
              <span class="icon icon-sindicato mx-1"></span>
              <span v-if="employee.core_employee.labor_unions.length == 0">
                Pactado
              </span>
              <span
                v-else
                v-for="item in employee.core_employee.labor_unions"
                :key="item.id"
              >
                {{ item.name }}
                <span
                  v-if="
                    item.id !=
                      employee.core_employee.labor_unions[
                        employee.core_employee.labor_unions.length - 1
                      ].id
                  "
                >
                  |
                </span>
              </span>
            </div>
          </div>
          <div class="title-status">
            <span class="font-weight-bold">Selecciona cada etapa</span> para ver
            su documentación
            <div style="position: relative">
              <StepProgress
                :processEmployee="employee"
                :dateKnowledge="report.date_knowledge"
              ></StepProgress>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div
            class="alert alert-warning text-center mb-4"
            v-if="process.status == 5 && employee.appeal_response == null"
          >
            <div
              v-if="employee.appeal != null && employee.appeal_response == null"
            >
              {{ employee.core_employee.name }} presentó un recurso de
              apelación, la dirección de soporte y la gerencia de relaciones
              laborales te enviarán su respuesta en los próximos
              <span class="font-weight-bold">4 días</span>
            </div>
            <div v-else-if="employee.appeal == null">
              La notificación de la sanción fue entregada, si en
              <span class="font-weight-bold">7 días</span>
              {{ employee.core_employee.name }} no presenta un recurso de
              revisión, el Business Partner podrá generar la
              <span class="font-weight-bold"
                >carta de ejecución de la sanción y cerrar el proceso.</span
              >
            </div>
          </div>
          <div
            class="alert alert-warning text-center mb-4"
            v-if="process.status == 6 && employee.review_response == null"
          >
            <div
              v-if="employee.review != null && employee.review_response == null"
            >
              {{ employee.core_employee.name }} presentó un recurso de revisión,
              la dirección de soporte y la gerencia de relaciones laborales te
              enviarán su respuesta en los próximos
              <span class="font-weight-bold">4 días</span>.
            </div>
            <div v-else-if="employee.review == null">
              La respuesta a la apelación fue entregada, si en
              <span class="font-weight-bold">7 días</span>
              {{ employee.core_employee.name }} no presenta un recurso de
              revisión, podrás generar la carta de ejecución de la sanción y
              cerrar el proceso.
            </div>
          </div>
          <div
            v-if="
              process.status == 2 &&
                (user.core_role_id == '2' || user.core_role_id == '4')
            "
            class="mb-4"
          >
            <QuestionRepository></QuestionRepository>
          </div>
          <template>
            <div class="accordion mx-auto" role="tablist">
              <b-card no-body class="mb-4" v-if="process.status == 1">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-1>
                    <span class="mx-4" v-if="user.core_role_id != '2'"></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else-if="
                        employee.proce_citations.length == 0 ||
                          citation.reschedule == true
                      "
                    ></span>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-else
                    ></span>
                    Datos generales de la citación
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td valign="top">Fecha de la citación</td>
                          <td width="20"></td>
                          <td width="55%" class="text-left date">
                            <span
                              v-if="
                                (employee.proce_citations.length != 0 ||
                                  user.core_role_id != '2') &&
                                  citation.reschedule == false
                              "
                            >
                              <u>{{
                                this.employee.proce_citations[
                                  this.employee.proce_citations.length - 1
                                ].day
                              }}</u>
                            </span>
                            <div v-else>
                              <input
                                @change="valDay()"
                                v-model="citation.d"
                                minlength="2"
                                maxlength="2"
                                class="input-1"
                                type="text"
                                placeholder="dd"
                              />

                              <select v-model="citation.m" class="select-1">
                                <option
                                  v-for="item in months"
                                  :value="item.id"
                                  :key="item.id"
                                >
                                  {{ item.name }}
                                </option>
                              </select>
                              <select v-model="citation.y" class="select-1">
                                <option :value="y">
                                  {{ y }}
                                </option>
                                <option :value="y + 1">
                                  {{ y + 1 }}
                                </option>
                              </select>
                            </div>
                            <div
                              class="alert alert-danger text-center mb-2"
                              v-if="
                                currentDate >
                                  citation.y +
                                    '-' +
                                    citation.m +
                                    '-' +
                                    citation.d && citation.d != ''
                              "
                            >
                              Solo puede seleccionar fechas en el futuro,
                              contando 2 días a partir de hoy
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Hora de la citación</td>
                          <td width="30"></td>
                          <td class="text-left date">
                            <span
                              v-if="
                                (employee.proce_citations.length != 0 ||
                                  user.core_role_id != '2') &&
                                  citation.reschedule == false
                              "
                            >
                              <u>{{
                                employee.proce_citations[
                                  employee.proce_citations.length - 1
                                ].hour
                              }}</u>
                            </span>
                            <div v-else>
                              <input
                                @change="valHHMM('h')"
                                v-model="citation.h"
                                minlength="2"
                                maxlength="2"
                                class="input-1"
                                type="text"
                                placeholder="HH"
                              />
                              <input
                                @change="valHHMM('m')"
                                v-model="citation.s"
                                minlength="2"
                                maxlength="2"
                                class="input-1"
                                type="text"
                                placeholder="MM"
                              />
                              <span @click="setAmPm()" class="am-pm">{{
                                citation.am_pm
                              }}</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Lugar de la citación</td>
                          <td width="20"></td>
                          <td class="text-left">
                            <span
                              v-if="
                                (employee.proce_citations.length != 0 ||
                                  user.core_role_id != '2') &&
                                  citation.reschedule == false
                              "
                            >
                              <u>{{
                                employee.proce_citations[
                                  employee.proce_citations.length - 1
                                ].where
                              }}</u>
                            </span>
                            <div v-else>
                              <label class="mr-5">
                                <input
                                  v-model="citation.post.where"
                                  name="priority"
                                  type="text"
                                  class="input-1"
                                />
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="employee.proce_citations.length > 0">
                          <td
                            v-if="
                              employee.proce_citations[
                                employee.proce_citations.length - 1
                              ].reschedule != null ||
                                citation.reschedule == true
                            "
                          >
                            Soporte
                          </td>
                          <td
                            width="20"
                            v-if="
                              employee.proce_citations[
                                employee.proce_citations.length - 1
                              ].reschedule != null ||
                                citation.reschedule == true
                            "
                          ></td>
                          <td
                            class="text-left"
                            v-if="
                              employee.proce_citations[
                                employee.proce_citations.length - 1
                              ].reschedule != null ||
                                citation.reschedule == true
                            "
                          >
                            <div
                              v-if="
                                employee.proce_state_id <= 2 &&
                                  citation.reschedule == true
                              "
                            >
                              <label class="mr-5 input-file">
                                <i>
                                  <span v-if="citation.file == ''">
                                    <b>Haz clic aquí</b> para cargar el soporte
                                  </span>
                                  <span v-else>
                                    {{ citation.file }}
                                  </span>
                                </i>
                                <input
                                  type="file"
                                  name="reschedule"
                                  id="citationRescheduleFile"
                                  @change="citationRescheduleFile(this)"
                                />
                              </label>
                            </div>
                            <div
                              v-else-if="
                                employee.proce_citations[
                                  employee.proce_citations.length - 1
                                ].reschedule != null
                              "
                            >
                              <a href="" class="text-blue">
                                <u>{{
                                  employee.proce_citations[
                                    employee.proce_citations.length - 1
                                  ].reschedule_name
                                }}</u>
                              </a>
                            </div>
                          </td>
                        </tr>
                        <tr
                          v-if="
                            user.core_role_id == '2' &&
                              employee.proce_diligences.length == 0
                          "
                        >
                          <td colspan="3" class="text-center">
                            <a
                              href="javascript:void(0)"
                              @click="citationReschedule()"
                              class="btn-save"
                              v-if="
                                employee.proce_citations.length > 0 &&
                                  citation.reschedule == false
                              "
                            >
                              + Nueva citación
                            </a>
                            <div v-else>
                              <a
                                href="javascript:void(0)"
                                class="btn-save mr-3 text-red"
                                @click="citationReschedule()"
                                v-if="citation.reschedule == true"
                              >
                                Cancelar
                              </a>
                              <a
                                href="javascript:void(0)"
                                class="btn-save"
                                @click="citationSave()"
                              >
                                <span class="icon icon-guardar mx-1"></span>
                                Guardar
                              </a>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  process.status == 1 && employee.proce_citations.length > 0
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-2>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-if="
                        employee.proce_citations[
                          employee.proce_citations.length - 1
                        ].evidence == null
                      "
                    ></span>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-else
                    ></span>
                    Evidencia de entrega de la citación
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div>
                              <table
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td v-if="user.core_role_id != '2'">
                                      Archivo
                                    </td>
                                    <td v-if="user.core_role_id != '2'">
                                      Cargado por
                                    </td>
                                    <td>Fecha</td>
                                    <td v-if="user.core_role_id == '2'">
                                      Estado
                                    </td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in employee.proce_citations"
                                    :key="item.id"
                                  >
                                    <td v-if="user.core_role_id != '2'">
                                      <span
                                        class="icon icon-upload mx-1"
                                        v-if="item.evidence != null"
                                      ></span>
                                      {{
                                        item.evidence_name || "Sin evidencia"
                                      }}
                                    </td>
                                    <td v-if="user.core_role_id != '2'">
                                      {{ item.core_employee.name }}
                                    </td>
                                    <td>
                                      {{ item.day }}
                                    </td>
                                    <td v-if="user.core_role_id == '2'">
                                      {{ item.state_detail.value }}
                                    </td>
                                    <td class="text-center">
                                      <div v-if="user.core_role_id == '2'">
                                        <a
                                          class="mr-4"
                                          v-if="item.evidence != null"
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              item.evidence
                                          "
                                        >
                                          <u>
                                            <span
                                              class="icon icon-descargar mx-1"
                                            ></span>
                                            {{ item.evidence_name }}
                                          </u>
                                        </a>
                                        <label
                                          class="mr-4 input-file text-center"
                                          v-if="
                                            employee.proce_diligences.length ==
                                              0
                                          "
                                        >
                                          <u>
                                            <span
                                              class="icon icon-upload mx-1"
                                              v-if="item.evidence == null"
                                            ></span>
                                            <span
                                              class="icon icon-upload mx-1"
                                              v-else
                                            ></span>
                                            <span v-if="item.evidence == null">
                                              Evidencia
                                            </span>
                                            <span v-else>Editar</span>
                                          </u>
                                          <input
                                            type="file"
                                            :id="
                                              'citationEvidenceFile' + item.id
                                            "
                                            @change="
                                              citationEvidenceFile(item.id)
                                            "
                                          />
                                        </label>
                                        <a
                                          href="javascript:void(0)"
                                          @click="citationCancel(item.id)"
                                          v-if="
                                            item.state != 33 &&
                                              employee.proce_diligences
                                                .length == 0
                                          "
                                        >
                                          <span
                                            class="icon icon-upload mx-1 ml-3"
                                          ></span>
                                          <u>Cancelar</u>
                                        </a>
                                      </div>
                                      <div v-else>
                                        <a href="">
                                          <span
                                            class="icon icon-upload mx-1"
                                          ></span>
                                        </a>
                                        <a href="">
                                          <span
                                            class="icon icon-upload mx-1"
                                          ></span>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-4" v-if="process.status == 2">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-3>
                    <span
                      class="icon icon-circle-check mx-4 icon-orange"
                      v-if="employee.proce_diligences.length > 0"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Acta de descargos firmada
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div v-if="user.core_role_id != '2'">
                              <table
                                v-if="employee.proce_diligences.length > 0"
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in employee.proce_diligences"
                                    :key="item.id"
                                  >
                                    <td>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ item.evidence_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ item.core_employee.name }}
                                    </td>
                                    <td>
                                      {{ item.created_at }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div v-else class="text-gray p-4 text-center">
                                Aún no se ha cargado nigún acta de descargos
                                para este proceso
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="user.core_role_id == '2'">
                                <div class="border-gray">
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div
                                        v-for="item in employee.proce_diligences"
                                        :key="item.id"
                                      >
                                        <!--div v-if="item.evidence"-->
                                        <span
                                          class="icon icon-descargar mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              item.evidence
                                          "
                                        >
                                          <u>{{ item.evidence_name }}</u>
                                        </a>
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearDiligenceFile()"
                                          v-if="
                                            employee.proce_penalty_id == null
                                          "
                                        ></span>
                                        <!--/div-->
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                          v-if="
                                            employee.proce_penalty_id == null
                                          "
                                        >
                                          Arrastra el acta de la diligencia o
                                          haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="diligenceAdd"
                                            @change="diligenceAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún acta de descargos
                                para este proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-4" v-if="process.status == 3">
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-4>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.proce_penalty_id != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Sanción
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td valign="top">Tipo de sanción</td>
                          <td width="20"></td>
                          <td width="55%" class="text-left date">
                            <div
                              v-if="
                                user.core_role_id == '2' &&
                                  employee.proce_penalties_evidence.length == 0
                              "
                            >
                              <label
                                v-for="item in penalties"
                                :key="item.id"
                                v-bind:class="
                                  employee.proce_penalty_id == null ||
                                  employee.proce_penalty_id == item.id
                                    ? 'mr-5 w-100'
                                    : 'mr-5 w-100 label-disabled'
                                "
                              >
                                <input
                                  name="penaltyRadio"
                                  v-model="employee.proce_penalty_id"
                                  :value="item.id"
                                  type="radio"
                                  @change="penaltyRadio(item)"
                                />
                                {{ item.name }}
                              </label>
                            </div>
                            <div
                              class="text-gray text-center"
                              v-else-if="employee.proce_penalty_id == null"
                            >
                              Aún no se ha sugerido ninguna sanción para este
                              proceso
                            </div>
                            <div class="text-blue text-center" v-else>
                              {{ employee.proce_penalty.name }}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="process.status == 3 && employee.proce_penalty_id != null"
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-5>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.proce_penalties_evidence.length > 0"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Evidencia de entrega de la sanción
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-5"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div v-if="user.core_role_id != '2'">
                              <table
                                v-if="
                                  employee.proce_penalties_evidence.length > 0
                                "
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in employee.proce_penalties_evidence"
                                    :key="item.id"
                                  >
                                    <td>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ item.evidence_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ item.core_employee.name }}
                                    </td>
                                    <td>
                                      {{ item.created_at }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado niguna evidencia de la
                                entrega de la sanción
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="user.core_role_id == '2'">
                                <div
                                  class="alert alert-warning text-center mb-4"
                                  v-if="
                                    employee.proce_penalty.labor_relations ==
                                      1 && laborRelation.state != 42
                                  "
                                >
                                  Debe esperar al concepto de relaciones
                                  laborales
                                </div>
                                <div class="border-gray" v-else>
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div
                                        v-for="item in employee.proce_penalties_evidence"
                                        :key="item.id"
                                      >
                                        <span
                                          class="icon icon-upload mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              item.file
                                          "
                                        >
                                          <u>{{ item.name }}</u>
                                        </a>

                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearPenaltyFile()"
                                          v-if="employee.appeal == null"
                                        ></span>
                                      </div>
                                    </div>
                                    <div
                                      v-if="employee.appeal == null"
                                      class="col-md-6"
                                    >
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                        >
                                          Arrastra el acta de la sanción o haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="penaltyFileAdd"
                                            @change="penaltyFileAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún acta de descargos
                                para este proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  process.status == 4 ||
                    process.status == 5 ||
                    (process.status == 8 && employee.appeal != null)
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-6>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.appeal != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    <span v-if="user.core_role_id == '2'">
                      Cargar apelación
                    </span>
                    <span v-else> Recurso de revisión </span>
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-6"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div
                              v-if="
                                (user.core_role_id != '2' &&
                                  user.core_role_id != '4') ||
                                  process.status == 8
                              "
                            >
                              <table
                                v-if="employee.appeal != null"
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ employee.appeal_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ employee.appeal_user.name }}
                                    </td>
                                    <td>
                                      {{ employee.appeal_date }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún recurso de revisión
                                para este proceso
                              </div>
                            </div>
                            <div v-else>
                              <div
                                v-if="
                                  user.core_role_id == '2' ||
                                    user.core_role_id == '4'
                                "
                              >
                                <div class="border-gray">
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div v-if="employee.appeal != null">
                                        <span
                                          class="icon icon-upload mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              employee.appeal
                                          "
                                        >
                                          <u>{{ employee.appeal_name }}</u>
                                        </a>
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearAppealFile()"
                                          v-if="
                                            employee.appeal_response == null
                                          "
                                        ></span>
                                      </div>
                                    </div>
                                    <div
                                      v-if="employee.appeal_response == null"
                                      class="col-md-6"
                                    >
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                        >
                                          Arrastra el recurso de revisión o haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="appealFileAdd"
                                            @change="appealFileAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún recurso de revisión
                                para este proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  (process.status == 4 || process.status == 5) &&
                    employee.appeal != null
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-4>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.appeal_response != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Cambiar sanción
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td valign="top">Tipo de sanción</td>
                          <td width="20"></td>
                          <td width="55%" class="text-left date">
                            <div
                              v-if="
                                user.core_role_id == '2' &&
                                  employee.appeal_response == null
                              "
                            >
                              <label
                                v-for="item in penalties"
                                :key="item.id"
                                v-bind:class="
                                  employee.proce_penalty_id == null ||
                                  employee.proce_penalty_id == item.id
                                    ? 'mr-5 w-100'
                                    : 'mr-5 w-100 label-disabled'
                                "
                              >
                                <input
                                  name="penaltyRadio"
                                  v-model="employee.proce_penalty_id"
                                  :value="item.id"
                                  type="radio"
                                  @change="penaltyRadio(item)"
                                />
                                {{ item.name }}
                              </label>
                            </div>
                            <div
                              class="text-gray text-center"
                              v-else-if="employee.proce_penalty_id == null"
                            >
                              Aún no se ha sugerido ninguna sanción para este
                              proceso
                            </div>
                            <div class="text-blue text-center" v-else>
                              {{ employee.proce_penalty.name }}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  ((process.status == 4 || process.status == 5) &&
                    employee.appeal != null) ||
                    (process.status == 8 && employee.appeal_response != null)
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-7>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.appeal_response != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Entrega de respuesta
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-7"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div
                              v-if="
                                (user.core_role_id != '2' &&
                                  user.core_role_id != '4') ||
                                  process.status == 8
                              "
                            >
                              <table
                                v-if="employee.appeal_response != null"
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <a
                                        :href="
                                          serverPath +
                                            '/api/v1/proceReports/file/download?file=' +
                                            employee.appeal_response
                                        "
                                      >
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ employee.appeal_response_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ employee.appeal_response_user.name }}
                                    </td>
                                    <td>
                                      {{ employee.appeal_response_date }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún recurso de revisión
                                para este proceso
                              </div>
                            </div>
                            <div v-else>
                              <div
                                v-if="
                                  user.core_role_id == '2' ||
                                    user.core_role_id == '4'
                                "
                              >
                                <div class="border-gray">
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div
                                        v-if="employee.appeal_response != null"
                                      >
                                        <span
                                          class="icon icon-upload mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              employee.appeal_response
                                          "
                                        >
                                          <u>{{
                                            employee.appeal_response_name
                                          }}</u>
                                        </a>
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearAppealResponseFile()"
                                          v-if="employee.review == null"
                                        ></span>
                                      </div>
                                    </div>
                                    <div
                                      v-if="employee.review == null"
                                      class="col-md-6"
                                    >
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                        >
                                          Arrastra el recurso de revisión o haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="appealResponseFileAdd"
                                            @change="appealResponseFileAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún recurso de revisión
                                para este proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  process.status == 6 ||
                    (process.status == 8 && employee.review != null)
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-8>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.review != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Cargar revisión
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-8"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div
                              v-if="
                                (user.core_role_id != '2' &&
                                  user.core_role_id != '4') ||
                                  process.status == 8
                              "
                            >
                              <table
                                v-if="employee.review != null"
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <a
                                        :href="
                                          serverPath +
                                            '/api/v1/proceReports/file/download?file=' +
                                            employee.review
                                        "
                                      >
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ employee.review_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ employee.review_user.name }}
                                    </td>
                                    <td>
                                      {{ employee.review_date }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún recurso de revisión
                                para este proceso
                              </div>
                            </div>
                            <div v-else>
                              <div
                                v-if="
                                  user.core_role_id == '2' ||
                                    user.core_role_id == '4'
                                "
                              >
                                <div class="border-gray">
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div v-if="employee.review != null">
                                        <span
                                          class="icon icon-upload mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              employee.review
                                          "
                                        >
                                          <u>{{ employee.review_name }}</u>
                                        </a>
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearReviewFile()"
                                          v-if="
                                            employee.review_response == null
                                          "
                                        ></span>
                                      </div>
                                    </div>
                                    <div
                                      v-if="employee.review_response == null"
                                      class="col-md-6"
                                    >
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                        >
                                          Arrastra el recurso de revisión o haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="reviewFileAdd"
                                            @change="reviewFileAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nigún recurso de revisión
                                para este proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="process.status == 6 && employee.review != null"
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-4>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.review_response != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Cambiar sanción
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr class="">
                          <td valign="top">Tipo de sanción</td>
                          <td width="20"></td>
                          <td width="55%" class="text-left date">
                            <div
                              v-if="
                                user.core_role_id == '2' &&
                                  employee.review_response == null
                              "
                            >
                              <label
                                v-for="item in penalties"
                                :key="item.id"
                                v-bind:class="
                                  employee.proce_penalty_id == null ||
                                  employee.proce_penalty_id == item.id
                                    ? 'mr-5 w-100'
                                    : 'mr-5 w-100 label-disabled'
                                "
                              >
                                <input
                                  name="penaltyRadio"
                                  v-model="employee.proce_penalty_id"
                                  :value="item.id"
                                  type="radio"
                                  @change="penaltyRadio(item)"
                                />
                                {{ item.name }}
                              </label>
                            </div>
                            <div
                              class="text-gray text-center"
                              v-else-if="employee.proce_penalty_id == null"
                            >
                              Aún no se ha sugerido ninguna sanción para este
                              proceso
                            </div>
                            <div class="text-blue text-center" v-else>
                              {{ employee.proce_penalty.name }}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  (process.status == 6 && employee.review != null) ||
                    (process.status == 8 && employee.review_response != null)
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-9>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.review_response != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Cargar respuesta firmada
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-9"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div
                              v-if="
                                (user.core_role_id != '2' &&
                                  user.core_role_id != '4') ||
                                  process.status == 8
                              "
                            >
                              <table
                                v-if="employee.review_response != null"
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <a
                                        :href="
                                          serverPath +
                                            '/api/v1/proceReports/file/download?file=' +
                                            employee.review_response
                                        "
                                      >
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ employee.review_response_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ employee.review_response_user.name }}
                                    </td>
                                    <td>
                                      {{ employee.review_response_date }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado niguna revisión para este
                                proceso
                              </div>
                            </div>
                            <div v-else>
                              <div
                                v-if="
                                  user.core_role_id == '2' ||
                                    user.core_role_id == '4'
                                "
                              >
                                <div class="border-gray">
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div
                                        v-if="employee.review_response != null"
                                      >
                                        <span
                                          class="icon icon-upload mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              employee.review_response
                                          "
                                        >
                                          <u>{{
                                            employee.review_response_name
                                          }}</u>
                                        </a>
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearReviewResponseFile()"
                                        ></span>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                        >
                                          Arrastra el recurso de revisión o haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="reviewResponseFileAdd"
                                            @change="reviewResponseFileAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado niguna revisión para este
                                proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card
                no-body
                class="mb-4"
                v-if="
                  process.status == 7 ||
                    (process.status == 8 && employee.closure != null)
                "
              >
                <b-card-header header-tag="header" class="p-0" role="tab">
                  <b-button class="bg-btn" block v-b-toggle.accordion-10>
                    <span
                      class="icon icon-circle-check mx-4 icon-green"
                      v-if="employee.closure != null"
                    ></span>
                    <span
                      class="icon icon-circle-clock mx-4 icon-orange"
                      v-else
                    ></span>
                    Ejecución de sanción firmada
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-10"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <table class="formTable w-100 mx-auto text-right">
                        <tr>
                          <td class="text-left">
                            <div
                              v-if="
                                user.core_role_id != '2' || process.status == 8
                              "
                            >
                              <table
                                v-if="employee.closure != null"
                                class="n-padding w-100 no-border"
                                border="1"
                              >
                                <thead>
                                  <tr>
                                    <td>Archivo</td>
                                    <td>Cargado por</td>
                                    <td>Fecha</td>
                                    <td>Acciones</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <a
                                        :href="
                                          serverPath +
                                            '/api/v1/proceReports/file/download?file=' +
                                            employee.closure
                                        "
                                      >
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                        {{ employee.closure_name }}
                                      </a>
                                    </td>
                                    <td>
                                      {{ employee.closure_user.name }}
                                    </td>
                                    <td>
                                      {{ employee.closure_date }}
                                    </td>
                                    <td class="text-center">
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                      <a href="">
                                        <span
                                          class="icon icon-upload mx-1"
                                        ></span>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nungún documento de
                                ejecución de la sanción para este proceso
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="user.core_role_id == '2'">
                                <div class="border-gray">
                                  <div class="row">
                                    <div class="col-md-6 pt-3">
                                      <div v-if="employee.closure != null">
                                        <span
                                          class="icon icon-upload mx-4"
                                        ></span>
                                        <a
                                          :href="
                                            serverPath +
                                              '/api/v1/proceReports/file/download?file=' +
                                              employee.closure
                                          "
                                        >
                                          <u>{{ employee.closure_name }}</u>
                                        </a>
                                        <span
                                          class="icon icon-eliminar-2 icon-red mx-4"
                                          @click="clearClosureFile()"
                                        ></span>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="p-3">
                                        <div
                                          class="input-file-2 text-gray font-size-12px"
                                        >
                                          Arrastra el documento de ejecución de
                                          la sanción o haz
                                          <span class="text-blue"
                                            >click aquí</span
                                          >.
                                          <input
                                            type="file"
                                            id="closureFileAdd"
                                            @change="closureFileAdd()"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-gray p-4 text-center" v-else>
                                Aún no se ha cargado nungún documento de
                                ejecución de la sanción para este proceso
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </template>
        </div>
        <div class="col-md-6 pt-3 border-left">
          <div>
            <div class="row">
              <div class="col-md-4">
                <h3>
                  {{ employee.proce_state.name }}
                </h3>
              </div>
              <div class="col-md-8 text-right">
                <p>
                  Última actualización: {{ formatDate(employee.updated_at) }}
                </p>
              </div>
            </div>
            <div
              v-bind:class="[
                laborRelation != null && user.core_role_id == '4'
                  ? 'alert-warning alert-warning m-0 p-0 mb-3'
                  : 'get-opinion alert-warning m-0 p-0 mb-3',
              ]"
              v-if="user.core_role_id == '2' || user.core_role_id == '4'"
            >
              <label class="w-100 m-0 p-0">
                <table class="w-100 m-0 p-0">
                  <tr>
                    <td v-if="process.status == 2 || process.status == 3">
                      <div v-if="user.core_role_id == '2'">
                        <input
                          type="checkbox"
                          v-if="laborRelation == null"
                          id="laborRelations"
                          @change="laborRelationsAdd()"
                        />
                        <span v-else class="mr-4"></span>
                        Solicitar asesoría de relaciones laborales:
                      </div>
                      <div v-else-if="laborRelation != null">
                        <span class="mr-4"></span>
                        El Business Partner solicitó tu asesoría
                      </div>
                    </td>
                    <td class="text-center">
                      <span v-if="laborRelation != null">
                        <span
                          class="icon icon-circle-clock mx-1 mr-2 icon-orange"
                          v-if="laborRelation.state_desc.id == 41"
                        ></span>
                        <span
                          class="icon icon-circle-check mx-1 mr-2 icon-green"
                          v-else
                        ></span>
                        {{ laborRelation.state_desc.value || "" }}
                      </span>
                    </td>
                    <td class="text-right">
                      <div>
                        <b-dropdown
                          size="lg"
                          right
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template #button-content>
                            <span
                              class="icon icon-comentarios mx-1 mr-2 font-size-16px"
                            ></span>
                          </template>
                          <b-dropdown-text>
                            <h3>Comentarios</h3>
                          </b-dropdown-text>
                          <b-dropdown-text>
                            <div class="dropdown-comment-content">
                              <div
                                v-for="lcomment in employee.proce_comments"
                                :key="lcomment.id"
                              >
                                <table width="300">
                                  <tr class="font-size-12px text-blue">
                                    <td>
                                      <span
                                        v-if="
                                          lcomment.core_employee.core_role.id !=
                                            '4'
                                        "
                                      >
                                        {{ lcomment.core_employee.name }}
                                      </span>
                                      <strong class="text-orange" v-else>
                                        {{ lcomment.core_employee.name }}
                                      </strong>
                                    </td>
                                    <td class="text-right text-gray">
                                      <span
                                        v-if="
                                          lcomment.core_employee.core_role.id !=
                                            '4'
                                        "
                                      >
                                        {{ lcomment.created_at }}
                                      </span>
                                      <strong class="text-orange" v-else>
                                        {{ lcomment.created_at }}
                                      </strong>
                                    </td>
                                  </tr>
                                </table>

                                <div
                                  class="dropdown-comment text-dark-gray mt-2"
                                >
                                  <p>
                                    {{ lcomment.text }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </b-dropdown-text>
                          <b-dropdown-text>
                            <div class="mt-3 dropdown-comment-text">
                              <div class="font-size-12px text-gray">
                                <i>Escribe un nuevo mensaje:</i>
                              </div>
                              <textarea
                                rows="5"
                                v-model="laborMessage"
                              ></textarea>
                              <div class="text-right">
                                <button
                                  class="btn"
                                  @click="laborRelationsCommentAdd()"
                                >
                                  Enviar
                                </button>
                              </div>
                            </div>
                          </b-dropdown-text>
                        </b-dropdown>
                      </div>
                    </td>
                  </tr>
                </table>
              </label>
            </div>
          </div>
          <Editor
            v-model="process.template"
            :disabled="editorDisabled"
            :header="employee.core_employee.society.header_img"
            :footer="employee.core_employee.society.footer_img"
          ></Editor>
          <div class="d-flex flex-row justify-content-center">
            <button class="btn btn-outline-info mx-2" @click="saveLetter()">
              Guardar
            </button>
            <button class="btn btn-outline-info mx-2" @click="download()">
              Descargar PDF
            </button>
          </div>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import Editor from "@/components/general/Editor.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
import StepProgress from "@/components/general/StepProgress";
import QuestionRepository from "@/components/general/QuestionRepository";

export default {
  name: "process",
  components: {
    MainBarMenu,
    Editor,
    StepProgress,
    QuestionRepository,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      text:
        "synth nesciunt you probably havent heard of them accusamus labore VHS.",
      currentDate: "",
      reportId: 0,
      id: 0,
      y: "",
      months: [
        { id: "01", name: "ENE" },
        { id: "02", name: "FEB" },
        { id: "03", name: "MAR" },
        { id: "04", name: "ABR" },
        { id: "05", name: "MAY" },
        { id: "06", name: "JUN" },
        { id: "07", name: "JUL" },
        { id: "08", name: "AGO" },
        { id: "09", name: "SEP" },
        { id: "10", name: "OCT" },
        { id: "11", name: "NOV" },
        { id: "12", name: "DIC" },
      ],
      citation: {
        y: "",
        m: "",
        d: "",
        h: "",
        s: "",
        i: "00",
        am_pm: "am",
        file: "",
        post: {
          date: "",
          where: "",
          letter: "** Letter  ** " + Math.random(),
          proce_employee_id: "",
        },
        reschedule: false,
      },
      laborMessage: "",
      variablesTemplate: {
        citation: {
          fechaCitacion: "{{FECHA_CITACION}}",
          horaCitacion: "{{HORA_CITACION}}",
        },
      },
    };
  },
  async beforeMount() {
    this.id = this.$route.params.id;
    this.reportId = this.$route.params.report;
    await this.actGetPenalties();
    await this.actGetReport(this.reportId);
    await this.actGetEmployee(this.id);
    await this.calendarDaysOfState();

    let date = new Date();
    this.y = date.getFullYear();
    this.citation.y = this.y;
    this.citation.m = date.getMonth() + 1;
    if (this.citation.m < 10) {
      this.citation.m = "0" + this.citation.m;
    } else {
      this.citation.m = "" + this.citation.m;
    }

    this.currentDate = date;
    this.currentDate.setDate(this.currentDate.getDate() + 2);
    this.currentDate =
      "" +
      this.currentDate.getFullYear() +
      "-" +
      String(this.currentDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(this.currentDate.getDate()).padStart(2, "0");
  },

  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modProcessEmployee", [
      "process",
      "employee",
      "report",
      "penalties",
    ]),
    laborRelation() {
      for (let i = 0; i < this.employee.proce_labor_relations.length; i++) {
        if (
          this.employee.proce_labor_relations[i].proce_state_id ==
          this.process.status
        ) {
          return this.employee.proce_labor_relations[i];
        }
      }
      return null;
    },
    editorDisabled() {
      return this.employee.proce_state_id === 4 && this.user.core_role_id !== 4
        ? true
        : false;
    },
  },
  watch: {
    employee() {
      //cargar template
      if (this.employee.proce_state_id === 1 && this.employee.letter_citation) {
        this.process.template = this.employee.letter_citation;
      } else if (
        this.employee.proce_state_id === 2 &&
        this.employee.letter_diligence
      ) {
        this.process.template = this.employee.letter_diligence;
      } else if (this.employee.proce_state_id === 3) {
        if (this.employee.letter_penalty) {
          this.process.template = this.employee.letter_penalty;
        } else {
          this.process.template = this.penalties.find(
            (penalty) => penalty.id === this.employee.proce_penalty_id
          ).template;
        }
      } else if (
        this.employee.proce_state_id === 4 &&
        this.employee.letter_resource
      ) {
        this.process.template = this.employee.letter_resource;
      } else if (
        this.employee.proce_state_id === 5 &&
        this.employee.letter_appeal
      ) {
        this.process.template = this.employee.letter_appeal;
      } else if (
        this.employee.proce_state_id === 6 &&
        this.employee.letter_review
      ) {
        this.process.template = this.employee.letter_review;
      } else if (
        this.employee.proce_state_id === 7 &&
        this.employee.letter_clousure
      ) {
        this.process.template = this.employee.letter_clousure;
      } else if (
        this.employee.proce_state_id === 8 &&
        this.employee.letter_finished
      ) {
        this.process.template = this.employee.letter_finished;
      } else {
        this.process.template = this.employee.proce_state.template;
      }

      //actualizar variables template

      if (this.employee.proce_state_id === 1 || this.employee.proce_state_id === 3) {
        let date = new Intl.DateTimeFormat("es", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        }).format(new Date());
        this.process.template = this.process.template.replaceAll(
          "{{FECHA_ACTUAL}}",
          date
        );
        this.process.template = this.process.template.replaceAll(
          "{{NOMBRE_COLABORADOR}}",
          this.employee.core_employee.name
        );
        this.process.template = this.process.template.replaceAll(
          "{{CC_COLABORADOR}}",
          this.employee.core_employee.cc
        );
      } else if (this.employee.proce_state_id === 2) {
        this.process.template = this.process.template.replaceAll(
          "{{NOMBRE_COLABORADOR}}",
          this.employee.core_employee.name
        );
        this.process.template = this.process.template.replaceAll(
          "{{CC_COLABORADOR}}",
          this.employee.core_employee.cc
        );
      }
    },
    "citation.d"() {
      let date = new Intl.DateTimeFormat("es", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(
        new Date(this.citation.y, this.citation.m - 1, this.citation.d)
      );

      this.process.template = this.process.template.replace(
        this.variablesTemplate.citation.fechaCitacion,
        date
      );
      this.variablesTemplate.citation.fechaCitacion = date;
    },
    "citation.m"() {
      let date = new Intl.DateTimeFormat("es", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(
        new Date(this.citation.y, this.citation.m - 1, this.citation.d)
      );
      this.process.template = this.process.template.replace(
        this.variablesTemplate.citation.fechaCitacion,
        date
      );
      this.variablesTemplate.citation.fechaCitacion = date;
    },
    "citation.y"() {
      let date = new Intl.DateTimeFormat("es", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(
        new Date(this.citation.y, this.citation.m - 1, this.citation.d)
      );
      this.process.template = this.process.template.replace(
        this.variablesTemplate.citation.fechaCitacion,
        date
      );
      this.variablesTemplate.citation.fechaCitacion = date;
    },
    "citation.h"() {
      let time = `${this.citation.h}:${this.citation.s} ${this.citation.am_pm}`;
      this.process.template = this.process.template.replace(
        this.variablesTemplate.citation.horaCitacion,
        time
      );
      this.variablesTemplate.citation.horaCitacion = time;
    },
    "citation.s"() {
      let time = `${this.citation.h}:${this.citation.s} ${this.citation.am_pm}`;
      this.process.template = this.process.template.replace(
        this.variablesTemplate.citation.horaCitacion,
        time
      );
      this.variablesTemplate.citation.horaCitacion = time;
    },
    "citation.am_pm"() {
      let time = `${this.citation.h}:${this.citation.s} ${this.citation.am_pm}`;
      this.process.template = this.process.template.replace(
        this.variablesTemplate.citation.horaCitacion,
        time
      );
      this.variablesTemplate.citation.horaCitacion = time;
    },
  },
  methods: {
    ...mapActions("modProcessEmployee", [
      "actGetEmployee",
      "actUptEmployee",
      "actGetReport",
      "actAddCitation",
      "actCancelCitation",
      "actUpdCitation",
      "actAddLaborRelations",
      "actAddLaborRelationsComment",
      "actAddDiligence",
      "actUdtDiligence",
      "actGetPenalties",
      "actAddPenaltyEvidence",
      "actUpdPenaltyEvidence",
      "actGetCalendarDays",
      "actGeneratePDF",
    ]),
    setAmPm() {
      if (this.citation.am_pm == "pm") {
        this.citation.am_pm = "am";
      } else {
        this.citation.am_pm = "pm";
      }
    },
    valDay() {
      if (this.citation.d > 31) {
        this.citation.d = 31;
      }
      if (this.citation.d <= 0) {
        this.citation.d = 1;
      }
      this.citation.d = String(this.citation.d).padStart(2, "0");
    },
    valHHMM(type) {
      if (type == "h") {
        if (this.citation.h > 12) {
          this.citation.h = 12;
        }
        if (this.citation.h < 0) {
          this.citation.h = 0;
        }
        this.citation.h = String(this.citation.h).padStart(2, "0");
      }
      if (type == "m") {
        if (this.citation.s > 59) {
          this.citation.s = 59;
        }
        if (this.citation.s < 0) {
          this.citation.s = 0;
        }
        this.citation.s = String(this.citation.s).padStart(2, "0");
      }
    },
    citationSave() {
      this.citation.post.proce_employee_id = this.id;
      var hh = this.citation.h + "";
      var pm = this.citation.am_pm;
      if (pm.toLowerCase() == "pm") {
        hh = hh * 1 + 12;
      }
      this.citation.post.date =
        this.citation.y +
        "-" +
        this.citation.m +
        "-" +
        this.citation.d +
        " " +
        hh +
        ":" +
        this.citation.s +
        ":" +
        this.citation.i;

      let formData = new FormData();

      if (this.citation.file != "" && this.citation.reschedule == true) {
        let file = document.querySelector("#citationRescheduleFile");
        formData.append("file", file.files[0]);
      }
      formData.append("date", this.citation.post.date);
      formData.append("where", this.citation.post.where);
      formData.append("letter", this.citation.post.letter);
      formData.append("proce_employee_id", this.id);

      this.saveLetter();
      this.actAddCitation(formData);
      if (this.citation.reschedule) {
        this.citationReschedule();
      }
    },
    citationReschedule() {
      this.citation.reschedule = !this.citation.reschedule;
    },
    citationCancel(id) {
      this.actCancelCitation(id);
    },
    citationRescheduleFile() {
      this.citation.file = document.getElementById(
        "citationRescheduleFile"
      ).value;
    },
    citationEvidenceFile(id) {
      let formData = new FormData();

      let file = document.querySelector("#citationEvidenceFile" + id);

      formData.append("file", file.files[0]);
      formData.append("letter", this.citation.post.letter);

      this.actUpdCitation({
        id: id,
        formData: formData,
      });
    },
    laborRelationsAdd() {
      if (document.querySelector("#laborRelations")) {
        if (document.querySelector("#laborRelations").checked) {
          this.actAddLaborRelations({
            proce_state_id: this.employee.proce_state_id,
            proce_employee_id: this.employee.id,
          });
        } else {
          document.querySelector("#laborRelations").checked = true;
        }
      }
    },
    laborRelationsCommentAdd() {
      if (this.laborMessage != "") {
        let proce_labor_relation_id = "";
        if (this.laborRelation != null) {
          proce_labor_relation_id = this.laborRelation.id;
        }
        this.actAddLaborRelationsComment({
          text: this.laborMessage,
          proce_employee_id: this.employee.id,
          proce_labor_relation_id: proce_labor_relation_id,
        }).then(() => {
          this.laborMessage = "";
        });
      }
    },
    diligenceAdd() {
      let formData = new FormData();

      let file = document.querySelector("#diligenceAdd");

      formData.append("file", file.files[0]);
      formData.append("letter", this.citation.post.letter);

      /*if (this.employee.proce_diligences.length > 0) {
        this.actUdtDiligence({
          id: this.employee.proce_diligences[0].id,
          formData: formData,
        });
      } else {*/
      formData.append("proce_employee_id", this.id);
      this.actAddDiligence(formData);
      /*}*/
    },
    clearDiligenceFile() {
      let formData = new FormData();

      formData.append("clearFile", 1);

      formData.append("letter", this.employee.proce_diligences[0].letter);

      if (this.employee.proce_diligences.length > 0) {
        this.actUdtDiligence({
          id: this.employee.proce_diligences[0].id,
          formData: formData,
        });
      }
    },
    penaltyRadio(penalty) {
      if (
        penalty.labor_relations == 1 &&
        this.employee.proce_penalties_evidence.length == 0
      ) {
        if (
          this.laborRelation == null &&
          document.querySelector("#laborRelations")
        ) {
          document.querySelector("#laborRelations").checked = true;
        }
        this.laborRelationsAdd();
      }
      this.actUptEmployee({
        id: this.id,
        formData: {
          penalty_text: "penalty_text penalty_text penalty_text penalty_text",
          proce_penalty_id: penalty.id,
        },
      });
    },
    penaltyFileAdd() {
      let formData = new FormData();

      let file = document.querySelector("#penaltyFileAdd");
      formData.append("file", file.files[0]);
      formData.append("proce_employee_id", this.id);

      if (this.employee.proce_penalties_evidence.length == 0) {
        this.actAddPenaltyEvidence(formData);
      } else {
        this.actUpdPenaltyEvidence({
          id: this.employee.proce_penalties_evidence[0].id,
          formData: formData,
        });
      }
    },
    clearPenaltyFile() {
      let formData = new FormData();

      formData.append("proce_employee_id", this.id);
      formData.append("clearFile", 1);

      if (this.employee.proce_penalties_evidence.length > 0) {
        this.actUpdPenaltyEvidence({
          id: this.employee.proce_penalties_evidence[0].id,
          formData: formData,
        });
      }
    },
    appealFileAdd() {
      let formData = new FormData();
      let file = document.querySelector("#appealFileAdd");
      formData.append("appeal", file.files[0]);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    appealResponseFileAdd() {
      let formData = new FormData();
      let file = document.querySelector("#appealResponseFileAdd");
      formData.append("appeal_response", file.files[0]);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    reviewFileAdd() {
      let formData = new FormData();
      let file = document.querySelector("#reviewFileAdd");
      formData.append("review", file.files[0]);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    reviewResponseFileAdd() {
      let formData = new FormData();
      let file = document.querySelector("#reviewResponseFileAdd");
      formData.append("review_response", file.files[0]);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    clearAppealFile() {
      let formData = new FormData();
      formData.append("clear_appeal", 1);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    clearAppealResponseFile() {
      let formData = new FormData();
      formData.append("clear_appeal_response", 1);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    clearReviewFile() {
      let formData = new FormData();
      formData.append("clea_review", 1);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    clearReviewResponseFile() {
      let formData = new FormData();
      formData.append("clear_review_response", 1);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    closureFileAdd() {
      let formData = new FormData();
      let file = document.querySelector("#closureFileAdd");
      formData.append("closure", file.files[0]);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    clearClosureFile() {
      let formData = new FormData();
      formData.append("clear_closure", 1);
      this.actUptEmployee({
        id: this.id,
        formData: formData,
      });
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
        const mo = new Intl.DateTimeFormat("es", { month: "short" })
          .format(d)
          .replace(".", "");
        const da = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(d);
        return `${da} ${mo.charAt(0).toUpperCase() + mo.slice(1)}, ${ye}`;
      } else {
        return "";
      }
    },
    saveLetter(restore = false) {
      let field;
      switch (this.employee.proce_state_id) {
        case 1:
          field = "letter_citation";
          break;
        case 2:
          field = "letter_diligence";
          break;
        case 3:
          field = "letter_penalty’";
          break;
        case 4:
          field = "letter_resource";
          break;
        case 5:
          field = "letter_appeal";
          break;
        case 6:
          field = "letter_review";
          break;
        case 7:
          field = "letter_clousure";
          break;
        case 8:
          field = "letter_finished";
          break;
        default:
          break;
      }

      if (this.process.template) {
        let formData = new FormData();
        formData.append(field, restore ? "" : this.process.template);
        this.actUptEmployee({
          id: this.id,
          formData: formData,
        });
      }
      return;
    },
    async calendarDaysOfState() {
      let stateSociety = this.employee.core_employee.society.proce_states.find(
        (state) => state.proce_state_id === this.employee.proce_state.id
      );

      let startDate;

      if (this.employee.proce_state.id == 1) {
        startDate = new Date(this.dateKnowledge);
      }
      if (this.employee.proce_state.id > 1) {
        startDate = new Date(
          this.employee.proce_citations[
            this.employee.proce_citations.length - 1
          ].date
        );
      }
      await this.actGetCalendarDays({
        startDate: startDate,
        workingDays: stateSociety.days,
      });
    },

    async download() {
      let response = await this.actGeneratePDF({
        text: this.process.template,
        header: this.employee.core_employee.society.header_img,
        footer: this.employee.core_employee.society.footer_img
      });
      if (response.data.file) {
        window.open(
          this.serverPath +
            "/api/v1/proceReports/file/download?file=" +
            response.data.file
        );
      }
    },
  },
};
</script>
<style scoped>
.title-status {
  font-size: 14px;
}
.am-pm {
  cursor: pointer;
}

.btn-outline-info {
  color: #1c3a4e !important;
  border-color: #1c3a4e !important;
  font-size: 14px;
  line-height: 21px;
}

.btn-outline-info:hover {
  background-color: #1c3a4e !important;
  color: #fff !important;
}
</style>
